// ==== LAJO — Latin American Jazz Orchestra ====
// All content is MOCK data for the frontend teaser. Real assets (video, logo, socials) are the actual ones from lajo.mx

export const assets = {
  logo: 'https://static.wixstatic.com/media/4a2ebb_cb7bfc0da6fa4e4aa4d65c25cdee6f5a~mv2.png/v1/fill/w_388,h_228,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_4157_PNG.png',
  heroVideo: 'https://video.wixstatic.com/video/11062b_0f1e951461494c1894d86c9ab85a11cf/1080p/mp4/file.mp4',
  heroPoster: 'https://static.wixstatic.com/media/11062b_0f1e951461494c1894d86c9ab85a11cff000.jpg/v1/fill/w_1905,h_765,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/11062b_0f1e951461494c1894d86c9ab85a11cff000.jpg',
  youtubeId: 'IxZMnjpIjcY',
  youtubeChannel: 'https://www.youtube.com/@LAJAZZORCHESTRA/videos',
  spotifyPlaylist: 'https://open.spotify.com/embed/playlist/71heH8LHjKTtAqnTXs4khn?utm_source=generator&theme=0',
  aboutImage: 'https://static.wixstatic.com/media/4a2ebb_943a086e654d44b1b675880cd1628a67.jpg/v1/fill/w_1000,h_1100,al_c,q_85,enc_auto/x.jpg',
  lauraImage: 'https://i.ytimg.com/vi/UhsYkyghRVM/maxresdefault.jpg',
  culturalImage: '/cultural-concert-cenart.jpg',
  directorImage: '/posters/isaias.jpg',
  albumImage: '/posters/big-band-revised.jpg',
};

// Real portrait photos from lajo.mx/portraits (Wix). Helper resizes on the fly.
export const wixImg = (id, w = 600, h = 750) =>
  `https://static.wixstatic.com/media/4a2ebb_${id}.jpg/v1/fill/w_${w},h_${h},al_c,q_80,enc_auto/x.jpg`;
export const wixImgFull = (id) =>
  `https://static.wixstatic.com/media/4a2ebb_${id}.jpg/v1/fill/w_1400,h_1600,al_c,q_88,enc_auto/x.jpg`;

export const portraits = [
  '0143200a55344153b4013ff4d8a77a00', '02f748cdc76743bbb1705a5a799f3e87',
  '09757d86c291488f94ffc0c1857c1c03', '296324fd37f64876b302daa3c735e7ac',
  '943a086e654d44b1b675880cd1628a67', '04018fb0678a4d499c357366b46eca4b',
  '0c7b802bc7374236a87efaf66769ef3e', '13625ba09a44493eb9538a8349a8cd79',
  '210f6a07921d4abe8697c9be9906bd46', '23417c55c53a42a1a1cfa54485c9e062',
  '31f0c506e49c4015a18287b5e650ae95', '4b8540f402444d1ab2f5c5aebfb671fe',
  '4fd22017006f45609a326238adb83078', '66e0abf4e5804faab91d72e8a019737d',
  '6e5b473ad53d4dff8c39aada06586abf', '7145b2b1e0954836b689b7e8d5f3faa7',
  '792f62b3f2cb491b8146fabf73622b37', '95ba7b00539f4719b459dd9770bf0b14',
  'b3125a70a4f2486dba212ff690ba9a69', 'b640742b2f3849bab7fa23666038a3d3',
  'bf83146bc41e4b218703a929006b675a', 'c0243881370540c6909b38fbe2a61d7e',
  'dcc95a3a0b6546de88afaf1a021703be', 'eafd59825a6e41c19c54c1ef0bb89bfb',
  'f98654ea00dd47f5807103eebc567207',
];

// Real videos from the LAJO YouTube channel. Thumbnails serve as real band imagery.
export const ytThumb = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
export const ytThumbHi = (id) => `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;

export const videos = [
  { id: 'IxZMnjpIjcY', cat: 'promo', title: { es: 'LAJO Promo 2026', en: 'LAJO Promo 2026' } },
  { id: '_u0eItcgHfg', cat: 'cultural', title: { es: 'Concierto The Beatles', en: 'The Beatles Concert' } },
  { id: 'AA3wE8wCNy8', cat: 'cultural', title: { es: 'Homenaje a Duke Ellington', en: 'Tribute to Duke Ellington' } },
  { id: 'UhsYkyghRVM', cat: 'singer', title: { es: 'Laura Dickinson en vivo', en: 'Laura Dickinson Live' } },
  { id: 'HzgCX95g2NA', cat: 'weddings', title: { es: 'Boda en vivo', en: 'Live Wedding' } },
  { id: 'YbbiVGhi9o4', cat: 'weddings', title: { es: 'Momentos de fiesta', en: 'Party Moments' } },
];

export const socials = [
  { name: 'YouTube', icon: 'Youtube', url: 'https://www.youtube.com/@LAJAZZORCHESTRA/featured' },
  { name: 'Instagram', icon: 'Instagram', url: 'https://www.instagram.com/latin_american_jazz_orchestra/' },
  { name: 'Spotify', icon: 'Music2', url: 'https://open.spotify.com/playlist/71heH8LHjKTtAqnTXs4khn?si=399085b8fe704a5c' },
  { name: 'Facebook', icon: 'Facebook', url: 'https://www.facebook.com/Latinamericanjazzorchestra/' },
  { name: 'WhatsApp', icon: 'MessageCircle', url: 'https://wa.me/525534653762' },
  { name: 'Telegram', icon: 'Send', url: 'https://t.me/+525534653762' },
  { name: 'Google Maps', icon: 'MapPin', url: 'https://maps.app.goo.gl/8kFhu9ufbNn1KTkz9' },
  { name: 'TikTok', icon: 'Music', url: 'https://www.tiktok.com/@lajazzorchestra' },
  { name: 'SoundCloud', icon: 'AudioLines', url: 'https://soundcloud.com/lajojazz' },
];

export const contactInfo = {
  phone: '+52 55 3465 3762',
  phoneRaw: '525534653762',
  email: 'LAjazzorchestra@hotmail.com',
  whatsapp: 'https://wa.me/525534653762',
  maps: 'https://maps.app.goo.gl/8kFhu9ufbNn1KTkz9',
  city: 'Cerca del Parque Hundido, CDMX',
};

export const galleryImages = [
  { src: 'https://images.pexels.com/photos/12448207/pexels-photo-12448207.jpeg', tag: 'stage' },
  { src: 'https://images.pexels.com/photos/12448173/pexels-photo-12448173.jpeg', tag: 'stage' },
  { src: 'https://images.unsplash.com/photo-1648572062439-caa7d601c77c', tag: 'brass' },
  { src: 'https://images.pexels.com/photos/28123410/pexels-photo-28123410.jpeg', tag: 'weddings' },
  { src: 'https://images.unsplash.com/photo-1499364615650-ec38552f4f34', tag: 'stage' },
  { src: 'https://images.pexels.com/photos/6405771/pexels-photo-6405771.jpeg', tag: 'weddings' },
  { src: 'https://images.unsplash.com/photo-1415201364774-f6f0bb35f28f', tag: 'brass' },
  { src: 'https://images.pexels.com/photos/16120229/pexels-photo-16120229.jpeg', tag: 'weddings' },
  { src: 'https://images.pexels.com/photos/14143406/pexels-photo-14143406.jpeg', tag: 'brass' },
  { src: 'https://images.unsplash.com/photo-1526478806334-5fd488fcaabc', tag: 'stage' },
  { src: 'https://images.pexels.com/photos/12689009/pexels-photo-12689009.jpeg', tag: 'weddings' },
  { src: 'https://images.pexels.com/photos/8044071/pexels-photo-8044071.jpeg', tag: 'stage' },
];

export const sectionImages = {
  ballroom: 'https://images.pexels.com/photos/12689009/pexels-photo-12689009.jpeg',
  banquet: 'https://images.pexels.com/photos/16935912/pexels-photo-16935912.jpeg',
  dining: 'https://images.pexels.com/photos/36873712/pexels-photo-36873712.jpeg',
};

export const pastConcerts = [
  { img: '/posters/ray-charles.jpg', title: 'Ray Charles con Big Band', venue: 'CUC de CDMX · Coyoacán' },
];

export const culturalPortfolio = {
  es: {
    bannerTitle: 'Conciertos Culturales',
    bannerSubtitle: 'Elegancia, virtuosismo y la fuerza del swing de la Época de Oro, fusionados con la riqueza sonora latinoamericana.',
    missionTitle: 'El arte de la Big Band re-imaginado',
    mission: 'LAJO nace de la convicción de que la música de las grandes orquestas es un patrimonio vivo y conmovedor. Con más de 15 años de trayectoria, fusionamos la sofisticación del jazz clásico con la energía de nuestro tiempo y la riqueza sonora latinoamericana.',
    features: ['17 músicos en escena', 'Repertorio de miles de obras', 'Formatos de 3 a 17 músicos', 'Arreglistas exclusivos'],
    directorEyebrow: 'Liderazgo musical',
    directorName: 'Isaías Jiménez',
    directorRole: 'Dirección, trompeta y arreglos',
    directorBio: 'Trompetista profesional, arreglista y director con más de 30 años de trayectoria internacional. Su maestría técnica y visión estética han posicionado a LAJO como una de las orquestas de jazz más respetadas de América Latina.',
    collabTitle: 'Ha compartido escenario con',
    collaborations: ['Glenn Miller Orchestra', "Paquito D'Rivera", 'Wayne Bergeron', 'Laura Dickinson', 'Juan Gabriel', 'Natalia Lafourcade', 'Jazz at Lincoln Center', 'Broadway & Orquestas Sinfónicas'],
    portfolioTitle: 'Portafolio de espectáculos',
    portfolioSubtitle: 'Conciertos temáticos y monumentales para festivales, teatros y recintos culturales.',
    pastTitle: 'Conciertos pasados',
    pastSubtitle: 'Un vistazo a las presentaciones que hemos llevado a teatros y recintos culturales.',
    albumEyebrow: 'Nueva producción discográfica',
    albumName: 'Big Band Revised',
    albumDesc: 'El nuevo álbum de la orquesta: sonidos modernos y composiciones originales que reinventan la tradición de las grandes bandas. Tradición, evolución y nuevo tiempo.',
    watch: 'Ver video',
    shows: [
      { n: '01', title: 'Jazz Masters', desc: 'Duke Ellington, John Coltrane y Wynton Marsalis: las obras que definieron la evolución del jazz.' },
      { n: '02', title: 'Frank Sinatra Tribute', desc: 'La era dorada de Las Vegas con los arreglos de Nelson Riddle, junto a la voz de Laura Dickinson.', video: 'RJ39hegEDHA', poster: '/posters/sinatra-laura.jpg' },
      { n: '03', title: 'Broadway in Concert', desc: 'Las grandes aperturas y joyas del teatro musical en un formato Big Band deslumbrante.', poster: '/posters/broadway.jpg' },
      { n: '04', title: 'Beatles Big Band', desc: 'Los éxitos de Liverpool transformados en sofisticadas suites de jazz. Estreno con éxito en el CUC de la UNAM.', video: '_u0eItcgHfg', poster: '/posters/beatles.jpg' },
      { n: '05', title: 'Tintán & Jazz Mexicano', desc: 'El swing pachuco y la época de oro del cine mexicano, con el actor Marcos Valdés.', poster: '/posters/tintan.jpg' },
      { n: '06', title: 'The Nutcracker Suite', desc: 'El clásico de Tchaikovsky en la histórica adaptación swing de Ellington y Strayhorn.', video: 'leOqsbatxPM' },
      { n: '07', title: 'Queen Big Band Experience', desc: 'La música de Queen con arreglos sinfónicos para Big Band: Bohemian Rhapsody, Don\u2019t Stop Me Now y más.', poster: '/posters/queen.jpg' },
      { n: '08', title: 'The Swing Era', desc: 'Homenaje a las legendarias Big Bands de los años 30 y 40 que hicieron bailar al mundo.', poster: '/posters/grandes-bandas.jpg' },
      { n: '09', title: 'Gaming Big Band', desc: 'Las bandas sonoras más icónicas de los videojuegos reinterpretadas en formato Big Band.' },
      { n: '10', title: 'Ray Charles Big Band', desc: 'Un homenaje al legado de Ray Charles: jazz, soul y arreglos orquestales con energía contemporánea.', poster: '/posters/ray-charles.jpg' },
      { n: '11', title: 'Hollywood Big Band', desc: 'Los grandes temas del cine, de Marvel a las bandas sonoras memorables, en arreglos espectaculares.' },
      { n: '12', title: 'Duke Ellington Tribute', desc: 'La era dorada del Cotton Club y las composiciones de Ellington con virtuosismo contemporáneo.', video: 'AA3wE8wCNy8', poster: '/posters/duke-ellington.jpg' },
      { n: '13', title: 'A Love Supreme · John Coltrane', desc: 'La suite espiritual de 1964 expandida a la riqueza orquestal de 17 instrumentos.', video: 'gwGucUDiTdY', poster: '/posters/love-supreme.jpg' },
      { n: '14', title: 'Wynton Marsalis & Big 12', desc: 'La Vitoria Suite: blues afroamericano, swing moderno e influencias latinas y flamencas.', video: 'be6DbaYWYns', poster: '/posters/wynton.jpg' },
    ],
    eduTitle: 'Programas educativos y clínicas',
    edu: [
      { t: 'Conciertos didácticos', d: 'Presentaciones guiadas que explican la historia del jazz y la magia de la improvisación en vivo para jóvenes y familias.' },
      { t: 'Masterclasses & clínicas', d: 'Sesiones sobre técnica de trompeta, sección de vientos, improvisación avanzada y arreglos para Big Band.' },
      { t: 'Ensayos abiertos & talleres', d: 'Experiencias inmersivas donde los estudiantes observan la dinámica de ensayo y dirección profesional.' },
    ],
    clientsTitle: 'Clientes y aliados institucionales',
    clients: ['Alcaldías de la CDMX', 'Ferias Internacionales del Libro & Secretaría de Cultura', 'UNAM — Centro Cultural Universitario', 'Hoteles de Gran Turismo & Wedding Planners', 'Festivales Internacionales de Jazz', 'Empresas trasnacionales & galas'],
    cta: 'Cotizar un concierto cultural',
  },
  en: {
    bannerTitle: 'Cultural Concerts',
    bannerSubtitle: 'Elegance, virtuosity and the power of Golden-Age swing, fused with the sonic richness of Latin America.',
    missionTitle: 'The art of the Big Band re-imagined',
    mission: 'LAJO was born from the belief that big-band music is a living, moving heritage. With over 15 years of history, we fuse the sophistication of classic jazz with the energy of our time and the sonic richness of Latin America.',
    features: ['17 musicians on stage', 'A repertoire of thousands of works', 'Formats from 3 to 17 musicians', 'Exclusive arrangers'],
    directorEyebrow: 'Musical leadership',
    directorName: 'Isaías Jiménez',
    directorRole: 'Director, trumpet & arrangements',
    directorBio: 'A professional trumpeter, arranger and director with over 30 years of international experience. His technical mastery and aesthetic vision have positioned LAJO as one of the most respected jazz orchestras in Latin America.',
    collabTitle: 'Has shared the stage with',
    collaborations: ['Glenn Miller Orchestra', "Paquito D'Rivera", 'Wayne Bergeron', 'Laura Dickinson', 'Juan Gabriel', 'Natalia Lafourcade', 'Jazz at Lincoln Center', 'Broadway & Symphony Orchestras'],
    portfolioTitle: 'Show portfolio',
    portfolioSubtitle: 'Themed, monumental concerts for festivals, theaters and cultural venues.',
    pastTitle: 'Past concerts',
    pastSubtitle: 'A glimpse of the performances we have brought to theaters and cultural venues.',
    albumEyebrow: 'New studio album',
    albumName: 'Big Band Revised',
    albumDesc: 'The orchestra\u2019s new album: modern sounds and original compositions that reinvent the big-band tradition. Tradition, evolution and a new era.',
    watch: 'Watch video',
    shows: [
      { n: '01', title: 'Jazz Masters', desc: 'Duke Ellington, John Coltrane and Wynton Marsalis: the works that defined the evolution of jazz.' },
      { n: '02', title: 'Frank Sinatra Tribute', desc: 'The golden age of Las Vegas with Nelson Riddle\u2019s arrangements, alongside the voice of Laura Dickinson.', video: 'RJ39hegEDHA', poster: '/posters/sinatra-laura.jpg' },
      { n: '03', title: 'Broadway in Concert', desc: 'The great overtures and musical-theater gems in a dazzling Big Band format.', poster: '/posters/broadway.jpg' },
      { n: '04', title: 'Beatles Big Band', desc: 'Liverpool\u2019s hits transformed into sophisticated jazz suites. Premiered to acclaim at UNAM\u2019s CUC.', video: '_u0eItcgHfg', poster: '/posters/beatles.jpg' },
      { n: '05', title: 'Tintán & Mexican Jazz', desc: 'Pachuco swing and the golden age of Mexican cinema, with actor Marcos Valdés.', poster: '/posters/tintan.jpg' },
      { n: '06', title: 'The Nutcracker Suite', desc: 'Tchaikovsky\u2019s classic in the historic swing adaptation by Ellington and Strayhorn.', video: 'leOqsbatxPM' },
      { n: '07', title: 'Queen Big Band Experience', desc: 'Queen\u2019s music with symphonic Big Band arrangements: Bohemian Rhapsody, Don\u2019t Stop Me Now and more.', poster: '/posters/queen.jpg' },
      { n: '08', title: 'The Swing Era', desc: 'A tribute to the legendary Big Bands of the 1930s and 40s that made the world dance.', poster: '/posters/grandes-bandas.jpg' },
      { n: '09', title: 'Gaming Big Band', desc: 'The most iconic video-game soundtracks reinterpreted in Big Band format.' },
      { n: '10', title: 'Ray Charles Big Band', desc: 'A tribute to Ray Charles\u2019 legacy: jazz, soul and orchestral arrangements with contemporary energy.', poster: '/posters/ray-charles.jpg' },
      { n: '11', title: 'Hollywood Big Band', desc: 'The great themes of cinema, from Marvel to memorable soundtracks, in spectacular arrangements.' },
      { n: '12', title: 'Duke Ellington Tribute', desc: 'The golden age of the Cotton Club and Ellington\u2019s compositions with contemporary virtuosity.', video: 'AA3wE8wCNy8', poster: '/posters/duke-ellington.jpg' },
      { n: '13', title: 'A Love Supreme · John Coltrane', desc: 'The 1964 spiritual suite expanded to the orchestral richness of 17 instruments.', video: 'gwGucUDiTdY', poster: '/posters/love-supreme.jpg' },
      { n: '14', title: 'Wynton Marsalis & Big 12', desc: 'The Vitoria Suite: African-American blues, modern swing and Latin and flamenco influences.', video: 'be6DbaYWYns', poster: '/posters/wynton.jpg' },
    ],
    eduTitle: 'Educational programs & clinics',
    edu: [
      { t: 'Educational concerts', d: 'Guided presentations explaining the history of jazz and the magic of live improvisation for youth and families.' },
      { t: 'Masterclasses & clinics', d: 'Sessions on trumpet technique, wind sections, advanced improvisation and Big Band arranging.' },
      { t: 'Open rehearsals & workshops', d: 'Immersive experiences where students observe professional rehearsal and conducting dynamics.' },
    ],
    clientsTitle: 'Clients & institutional partners',
    clients: ['Mexico City boroughs', 'International Book Fairs & Ministry of Culture', 'UNAM — University Cultural Center', 'Luxury Hotels & Wedding Planners', 'International Jazz Festivals', 'Multinational companies & galas'],
    cta: 'Quote a cultural concert',
  },
};

export const content = {
  es: {
    nav: { home: 'Inicio', about: 'Nosotros', services: 'Servicios', videos: 'Videos', cultural: 'Eventos Culturales', laura: 'Laura Dickinson', gallery: 'Galería', packages: 'Paquetes', faq: 'FAQ', contact: 'Contacto', cta: 'Cotizar' },
    hero: {
      eyebrow: 'Big Band · Ciudad de México',
      title: 'Latin American\nJazz Orchestra',
      subtitle: 'La orquesta en vivo que convierte tu boda o evento en una noche inolvidable.',
      ctaPrimary: 'Solicitar cotización',
      ctaSecondary: 'Ver video',
      scroll: 'Descubre',
    },
    about: {
      eyebrow: 'Nosotros',
      title: 'Elegancia que se escucha',
      p1: 'Latin American Jazz Orchestra es una big band de músicos profesionales con base en la Ciudad de México, especializada en música en vivo para bodas, eventos corporativos y celebraciones de alto nivel.',
      p2: 'Del jazz y el swing clásico al pop, la salsa y los boleros, adaptamos nuestro repertorio y formato a tu evento —desde un trío íntimo de coctel hasta la orquesta completa que enciende la pista.',
      stats: [
        { value: '15+', label: 'Años de experiencia' },
        { value: '500+', label: 'Eventos realizados' },
        { value: '18', label: 'Músicos en escena' },
        { value: '1000+', label: 'Canciones en repertorio' },
      ],
    },
    video: { eyebrow: 'Promo 2026', title: 'Míranos en acción', subtitle: 'Un vistazo a la energía y el sonido de LAJO en vivo.' },
    videosSection: {
      eyebrow: 'Videos',
      title: 'Nuestra música en video',
      subtitle: 'Bodas, fiestas y presentaciones en vivo. Más de 300 videos en YouTube e Instagram.',
      more: 'Ver más en YouTube',
      filters: { all: 'Todos', weddings: 'Bodas & Fiestas', cultural: 'Culturales', singer: 'Cantante', promo: 'Promo' },
    },
    cultural: {
      eyebrow: 'Eventos Culturales',
      title: 'No solo eventos privados',
      subtitle: 'También llevamos la orquesta a conciertos, teatros y tributos culturales.',
      intro: 'La Latin American Jazz Orchestra revive la era dorada del swing y las big bands con espectáculos temáticos de gran formato. Del rock británico al jazz clásico, creamos conciertos y homenajes que emocionan a cualquier público.',
      shows: [
        { id: '_u0eItcgHfg', title: 'Concierto The Beatles', desc: 'Un tributo sinfónico-jazz a los clásicos de The Beatles, con arreglos originales para big band.' },
        { id: 'AA3wE8wCNy8', title: 'Homenaje a Duke Ellington', desc: 'Celebramos al gigante del jazz con un repertorio que rinde honor a la era dorada del swing.' },
      ],
      cta: 'Cotizar un evento cultural',
      seeAll: 'Ver conciertos culturales',
    },
    laura: {
      eyebrow: 'Voz Invitada',
      title: 'Laura Dickinson',
      role: 'Cantante principal',
      p1: 'Laura Dickinson es la voz que envuelve a la Latin American Jazz Orchestra. Con una interpretación elegante y llena de matices, se mueve con naturalidad entre el jazz, el swing, el pop y el bolero.',
      p2: 'Su presencia escénica y su timbre cálido convierten cada canción en un momento memorable, ya sea en el primer baile de una boda o en el escenario de un gran concierto.',
      albumTitle: 'Su álbum en Spotify',
      cta: 'Solicitar a Laura para tu evento',
    },
    services: {
      eyebrow: 'Servicios',
      title: 'Música en vivo para cada momento',
      subtitle: 'Un formato para cada tipo de evento, con la calidad de una gran orquesta.',
      items: [
        { icon: 'Heart', title: 'Bodas', desc: 'Ceremonia, coctel y fiesta. Música que acompaña cada momento de tu día especial.' },
        { icon: 'Building2', title: 'Eventos corporativos', desc: 'Galas, cenas de fin de año y lanzamientos con una puesta en escena impecable.' },
        { icon: 'PartyPopper', title: 'Fiestas privadas', desc: 'Cumpleaños, aniversarios y celebraciones que se convierten en una gran noche.' },
        { icon: 'Wine', title: 'Set de coctel & jazz', desc: 'Ambiente sofisticado con un trío o cuarteto para recepciones y cenas.' },
        { icon: 'Sparkles', title: 'XV años & sociales', desc: 'Show completo con arreglos a medida para las entradas y momentos clave.' },
        { icon: 'Music4', title: 'Show a la medida', desc: 'Arreglos exclusivos, canciones especiales y producción personalizada.' },
      ],
    },
    gallery: { eyebrow: 'Galería', title: 'Momentos LAJO', subtitle: 'Escenario, metales y celebraciones inolvidables.',
      filters: { all: 'Todo', stage: 'En escena', brass: 'Metales', weddings: 'Bodas' } },
    music: {
      eyebrow: 'Repertorio',
      title: 'Nuestro sonido',
      subtitle: 'Escucha nuestra playlist y descubre la versatilidad de la orquesta.',
      genres: ['Jazz & Swing', 'Salsa & Latin', 'Pop & Rock', 'Boleros', 'Funk & Soul', 'Big Band Clásico'],
    },
    packages: {
      eyebrow: 'Paquetes',
      title: 'Formaciones y formatos',
      subtitle: 'Elige la formación ideal para tu evento. Cada paquete se ofrece en 1 o 2 horas.',
      startFrom: 'Los paquetes comienzan en',
      startPrice: '$32,999 MXN',
      durationLabel: 'Duración',
      badge: 'Más solicitado',
      cta: 'Solicitar cotización',
      elementsLabel: 'Integrantes',
      items: [
        { name: 'Mini Big Band', elements: '8 músicos + cantante', durations: ['1 hora', '2 horas'] },
        { name: 'Big Band Standard', elements: '11 músicos + cantante', durations: ['1 hora', '2 horas'], popular: true },
        { name: 'Big Band Full', elements: '14 músicos + cantante', durations: ['1 hora', '2 horas'] },
        { name: 'Big Band Deluxe', elements: '16 músicos + cantante', durations: ['1 hora', '2 horas'] },
      ],
      showsTitle: 'Artistas invitados y shows especiales',
      watch: 'Ver video',
      shows: [
        { name: 'Laura Dickinson', subtitle: '"The Best Is Yet To Come" · Show internacional', details: 'Show de 2 horas. Incluye Big Band (15 músicos), hospedaje, viáticos, vuelos, honorarios y equipo de audio.', video: 'RJ39hegEDHA' },
        { name: 'Lucho Aguilar', subtitle: '"My Way" · Show en vivo', details: 'Artista invitado disponible por hora para engalanar tu evento.', video: 'ChDql4j7A48' },
      ],
      specsTitle: 'Especificaciones y requerimientos',
      specs: [
        'Equipo de audio: se cotiza según el número de invitados.',
        'No incluye escenario, luces, máquina de humo ni equipo de sonido masivo.',
        'Show ideal para hasta 250 invitados. Para más de 300 personas se requiere equipo de sonido masivo.',
      ],
      note: 'No publicamos la lista completa de precios. Solicita tu cotización personalizada y te enviamos la propuesta ideal.',
    },
    testimonials: {
      eyebrow: 'Reseñas',
      title: 'Lo que dicen nuestros clientes',
      note: 'Reseñas verificadas de Bodas.com.mx y Google.',
      ratings: [
        { source: 'Bodas.com.mx', score: '4.6', url: 'https://www.bodas.com.mx/musica-para-bodas/american-jazz-orchestra-big-band--e119431' },
        { source: 'Google', score: '4.0', url: 'https://maps.app.goo.gl/8kFhu9ufbNn1KTkz9' },
      ],
      items: [
        { name: 'Mayela', role: 'Boda · Bodas.com.mx', rating: 5, quote: 'Excelente servicio, me encantaron cómo tocaron. Valió cada peso que pagamos. Fueron uno de los principales proveedores que hicieron mi boda única y memorable. Los recomiendo al 100%.' },
        { name: 'Fernando Pérez Morales', role: 'Boda · Google', rating: 5, quote: 'Estamos muy agradecidos por la calidad y el profesionalismo en nuestra boda. Siempre atentos y deleitaron a nuestros invitados con piezas musicales increíbles. Muy recomendables.' },
        { name: 'Irma', role: 'Boda · Bodas.com.mx', rating: 4, quote: 'Muy buenos músicos y calidad. Sin duda, ayudan a generar un ambiente de elegancia en tu fiesta.' },
        { name: 'Hacienda Santiago Texmelucan', role: 'Local Guide · Google', rating: 5, quote: 'Tocan muy bien, son puntuales y flexibles.' },
      ],
    },
    faq: {
      eyebrow: 'Preguntas frecuentes',
      title: 'Todo lo que necesitas saber',
      items: [
        { q: '¿Cuánto tiempo tocan?', a: 'Nuestros sets estándar son de 3 a 4 horas divididos en bloques, con música ambiental entre sets. Podemos extender según tu evento.' },
        { q: '¿Cubren la Ciudad de México y otros estados?', a: 'Sí. Tenemos base en la CDMX y viajamos a todo el país. Para eventos foráneos se cotizan viáticos.' },
        { q: '¿Aprenden una canción especial?', a: '¡Claro! Preparamos arreglos exclusivos para tu primer baile o momentos clave sin costo adicional en los paquetes Big Band y Orquesta.' },
        { q: '¿Incluyen equipo de audio e iluminación?', a: 'Todos los paquetes incluyen audio profesional. La iluminación escénica está incluida desde el paquete Big Band.' },
        { q: '¿Cómo reservo mi fecha?', a: 'Con un anticipo del 50% apartamos tu fecha. El resto se liquida el día del evento.' },
      ],
    },
    contact: {
      eyebrow: 'Contacto',
      title: 'Hablemos de tu evento',
      subtitle: 'Cuéntanos los detalles y te enviamos una propuesta a la medida.',
      form: { name: 'Nombre', email: 'Correo', phone: 'Teléfono', type: 'Tipo de evento', date: 'Fecha del evento', pickDate: 'Elegir fecha', place: 'Lugar de tu evento', size: 'Tamaño del evento', message: 'Mensaje', submit: 'Enviar solicitud', types: ['Boda', 'Evento corporativo', 'Fiesta privada', 'Evento cultural', 'XV años', 'Otro'], sizes: ['20 - 250 invitados', '250 - 500 invitados', '500+ invitados'] },
      success: '¡Gracias! Hemos recibido tu solicitud. Te contactaremos muy pronto.',
      infoTitle: 'Información directa',
      quickCall: 'Llámanos',
      quickWa: 'WhatsApp',
    },
    footer: { tagline: 'Música en vivo de alto nivel para bodas y eventos en la Ciudad de México.', links: 'Navegación', follow: 'Síguenos', rights: 'Todos los derechos reservados.' },
  },
  en: {
    nav: { home: 'Home', about: 'About', services: 'Services', videos: 'Videos', cultural: 'Cultural Events', laura: 'Laura Dickinson', gallery: 'Gallery', packages: 'Packages', faq: 'FAQ', contact: 'Contact', cta: 'Get a quote' },
    hero: {
      eyebrow: 'Big Band · Mexico City',
      title: 'Latin American\nJazz Orchestra',
      subtitle: 'The live orchestra that turns your wedding or event into an unforgettable night.',
      ctaPrimary: 'Request a quote',
      ctaSecondary: 'Watch video',
      scroll: 'Discover',
    },
    about: {
      eyebrow: 'About us',
      title: 'Elegance you can hear',
      p1: 'Latin American Jazz Orchestra is a big band of professional musicians based in Mexico City, specializing in live music for weddings, corporate events and high-end celebrations.',
      p2: 'From classic jazz and swing to pop, salsa and boleros, we tailor our repertoire and format to your event — from an intimate cocktail trio to the full orchestra that lights up the dance floor.',
      stats: [
        { value: '15+', label: 'Years of experience' },
        { value: '500+', label: 'Events performed' },
        { value: '18', label: 'Musicians on stage' },
        { value: '1000+', label: 'Songs in repertoire' },
      ],
    },
    video: { eyebrow: 'Promo 2026', title: 'See us in action', subtitle: 'A glimpse of the energy and sound of LAJO live.' },
    videosSection: {
      eyebrow: 'Videos',
      title: 'Our music in video',
      subtitle: 'Weddings, parties and live performances. Over 300 videos on YouTube and Instagram.',
      more: 'See more on YouTube',
      filters: { all: 'All', weddings: 'Weddings & Parties', cultural: 'Cultural', singer: 'Vocalist', promo: 'Promo' },
    },
    cultural: {
      eyebrow: 'Cultural Events',
      title: 'Not only private events',
      subtitle: 'We also bring the orchestra to concerts, theaters and cultural tributes.',
      intro: 'The Latin American Jazz Orchestra revives the golden age of swing and big bands with large-scale themed shows. From British rock to classic jazz, we create concerts and tributes that move any audience.',
      shows: [
        { id: '_u0eItcgHfg', title: 'The Beatles Concert', desc: 'A symphonic-jazz tribute to The Beatles classics, with original big band arrangements.' },
        { id: 'AA3wE8wCNy8', title: 'Tribute to Duke Ellington', desc: 'We celebrate the jazz giant with a repertoire that honors the golden age of swing.' },
      ],
      cta: 'Quote a cultural event',
      seeAll: 'See cultural concerts',
    },
    laura: {
      eyebrow: 'Guest Voice',
      title: 'Laura Dickinson',
      role: 'Lead vocalist',
      p1: 'Laura Dickinson is the voice that wraps around the Latin American Jazz Orchestra. With an elegant, nuanced delivery, she moves effortlessly between jazz, swing, pop and bolero.',
      p2: 'Her stage presence and warm tone turn every song into a memorable moment, whether it is the first dance at a wedding or the stage of a grand concert.',
      albumTitle: 'Her album on Spotify',
      cta: 'Request Laura for your event',
    },
    services: {
      eyebrow: 'Services',
      title: 'Live music for every moment',
      subtitle: 'A format for every kind of event, with the quality of a great orchestra.',
      items: [
        { icon: 'Heart', title: 'Weddings', desc: 'Ceremony, cocktail and party. Music for every moment of your special day.' },
        { icon: 'Building2', title: 'Corporate events', desc: 'Galas, year-end dinners and launches with flawless staging.' },
        { icon: 'PartyPopper', title: 'Private parties', desc: 'Birthdays, anniversaries and celebrations that become one great night.' },
        { icon: 'Wine', title: 'Cocktail & jazz set', desc: 'A sophisticated mood with a trio or quartet for receptions and dinners.' },
        { icon: 'Sparkles', title: 'Sweet 15 & socials', desc: 'A full show with custom arrangements for entrances and key moments.' },
        { icon: 'Music4', title: 'Bespoke show', desc: 'Exclusive arrangements, special songs and fully custom production.' },
      ],
    },
    gallery: { eyebrow: 'Gallery', title: 'LAJO moments', subtitle: 'Stage, brass and unforgettable celebrations.',
      filters: { all: 'All', stage: 'On stage', brass: 'Brass', weddings: 'Weddings' } },
    music: {
      eyebrow: 'Repertoire',
      title: 'Our sound',
      subtitle: 'Play our playlist and discover the versatility of the orchestra.',
      genres: ['Jazz & Swing', 'Salsa & Latin', 'Pop & Rock', 'Boleros', 'Funk & Soul', 'Classic Big Band'],
    },
    packages: {
      eyebrow: 'Packages',
      title: 'Formations & formats',
      subtitle: 'Choose the ideal formation for your event. Every package is offered in 1 or 2 hours.',
      startFrom: 'Packages start at',
      startPrice: '$32,999 MXN',
      durationLabel: 'Duration',
      badge: 'Most requested',
      cta: 'Request a quote',
      elementsLabel: 'Line-up',
      items: [
        { name: 'Mini Big Band', elements: '8 musicians + vocalist', durations: ['1 hour', '2 hours'] },
        { name: 'Big Band Standard', elements: '11 musicians + vocalist', durations: ['1 hour', '2 hours'], popular: true },
        { name: 'Big Band Full', elements: '14 musicians + vocalist', durations: ['1 hour', '2 hours'] },
        { name: 'Big Band Deluxe', elements: '16 musicians + vocalist', durations: ['1 hour', '2 hours'] },
      ],
      showsTitle: 'Guest artists & special shows',
      watch: 'Watch video',
      shows: [
        { name: 'Laura Dickinson', subtitle: '"The Best Is Yet To Come" · International show', details: '2-hour show. Includes Big Band (15 musicians), lodging, travel, flights, fees and audio equipment.', video: 'RJ39hegEDHA' },
        { name: 'Lucho Aguilar', subtitle: '"My Way" · Live show', details: 'Guest artist available by the hour to elevate your event.', video: 'ChDql4j7A48' },
      ],
      specsTitle: 'Specifications & requirements',
      specs: [
        'Audio equipment: quoted according to the number of guests.',
        'Does not include stage, lighting, fog machine or large-scale sound system.',
        'Show ideal for up to 250 guests. For 300+ people a large-scale sound system is required.',
      ],
      note: 'We do not publish a full price list. Request your personalized quote and we will send you the ideal proposal.',
    },
    testimonials: {
      eyebrow: 'Reviews',
      title: 'What our clients say',
      note: 'Verified reviews from Bodas.com.mx and Google.',
      ratings: [
        { source: 'Bodas.com.mx', score: '4.6', url: 'https://www.bodas.com.mx/musica-para-bodas/american-jazz-orchestra-big-band--e119431' },
        { source: 'Google', score: '4.0', url: 'https://maps.app.goo.gl/8kFhu9ufbNn1KTkz9' },
      ],
      items: [
        { name: 'Mayela', role: 'Wedding · Bodas.com.mx', rating: 5, quote: 'Excellent service, I loved the way they played. Worth every peso we paid. They were one of the key vendors that made my wedding unique and memorable. I recommend them 100%.' },
        { name: 'Fernando Pérez Morales', role: 'Wedding · Google', rating: 5, quote: 'We are so grateful for the quality and professionalism at our wedding. They were always attentive and delighted our guests with such incredible musical pieces. Highly recommended.' },
        { name: 'Irma', role: 'Wedding · Bodas.com.mx', rating: 4, quote: 'Very good musicians and quality. They definitely help create an atmosphere of elegance at your party.' },
        { name: 'Hacienda Santiago Texmelucan', role: 'Local Guide · Google', rating: 5, quote: 'They play very well, they are punctual and flexible.' },
      ],
    },
    faq: {
      eyebrow: 'FAQ',
      title: 'Everything you need to know',
      items: [
        { q: 'How long do you play?', a: 'Our standard sets run 3 to 4 hours in blocks, with ambient music between sets. We can extend depending on your event.' },
        { q: 'Do you cover Mexico City and other states?', a: 'Yes. We are based in CDMX and travel nationwide. Travel expenses are quoted for out-of-town events.' },
        { q: 'Will you learn a special song?', a: 'Of course! We prepare exclusive arrangements for your first dance or key moments at no extra cost on Big Band and Orchestra packages.' },
        { q: 'Do you include audio and lighting?', a: 'All packages include professional audio. Stage lighting is included from the Big Band package onward.' },
        { q: 'How do I book my date?', a: 'A 50% deposit secures your date. The balance is settled on the day of the event.' },
      ],
    },
    contact: {
      eyebrow: 'Contact',
      title: "Let's talk about your event",
      subtitle: 'Tell us the details and we will send you a tailored proposal.',
      form: { name: 'Name', email: 'Email', phone: 'Phone', type: 'Event type', date: 'Event date', pickDate: 'Pick a date', place: 'Event location', size: 'Event size', message: 'Message', submit: 'Send request', types: ['Wedding', 'Corporate event', 'Private party', 'Cultural event', 'Sweet 15', 'Other'], sizes: ['20 - 250 guests', '250 - 500 guests', '500+ guests'] },
      success: 'Thank you! We received your request and will contact you very soon.',
      infoTitle: 'Direct info',
      quickCall: 'Call us',
      quickWa: 'WhatsApp',
    },
    footer: { tagline: 'High-end live music for weddings and events in Mexico City.', links: 'Navigation', follow: 'Follow us', rights: 'All rights reserved.' },
  },
};
